import { ReactElement } from "react";

import { CampaignContactAudienceImportArgs } from "~frontend/__generated__/graphql";

import { CampaignForEditor } from "../../types";
import LegacySubscriberImport from "./LegacySubscriberImport";
import SubscriberTargeting from "./SubscriberTargeting";

export default function SubscriberImport({
  campaign,
  previousJobArgs,
  readOnly,
}: {
  campaign: CampaignForEditor;
  previousJobArgs?: CampaignContactAudienceImportArgs | null;
  readOnly?: boolean;
}): ReactElement {
  const useLegacyImportUI = !!previousJobArgs?.legacyFilter;

  return useLegacyImportUI ? (
    <LegacySubscriberImport campaign={campaign} />
  ) : (
    <SubscriberTargeting
      campaign={campaign}
      previousJobFilters={previousJobArgs?.filter ?? null}
      readOnly={readOnly}
    />
  );
}
